import { CSSProperties } from "react";

export const XSpiceSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={width}
      height={(width / 25) * 22}
      viewBox="0 0 25 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M18.5 1H7L1.5 11L7 21H18.5L24 11L18.5 1Z"
        fill="url(#paint0_linear_219_404)"
        stroke="#6F6E75"
        strokeOpacity="0.91"
      />
      <defs>
        <linearGradient
          id="paint0_linear_219_404"
          x1="12.5"
          y1="1"
          x2="12.5"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF785C" />
          <stop offset="1" stopColor="#C2541D" />
        </linearGradient>
      </defs>
    </svg>
  );
};
